import classNames from 'classnames'
import Headers from 'components/home/common/typography/Headers'
import Paragraphs from 'components/home/common/typography/Paragraphs'
import SectionHeaders from 'components/home/common/typography/SectionHeaders'
import React from 'react'

interface PageHeaderProps {
  label?: string | null
  heading: string
  subheading?: string
  className?: {
    container?: string
    heading?: string
    subheading?: string
  }
}

const PageHeader = ({
  label,
  heading,
  subheading,
  className,
}: PageHeaderProps) => {
  return (
    <div className={classNames('flex flex-col items-center px-40 pt-24', className?.container)}>
      {
        label && (
          <SectionHeaders.MD className="mb-12 uppercase text-primary-fresh lg:hidden">
            {label}
          </SectionHeaders.MD>
        )
      }

      <Headers.BaseTitle className="mb-8 text-center text-grey-900 lg:!font-normal text-32 md:text-36">
        {heading}
      </Headers.BaseTitle>

      {subheading && (
        <Paragraphs.SM className={classNames(
          'text-grey-300 leading-20',
          className?.subheading,
        )}>
          {subheading}
        </Paragraphs.SM>
      )}
    </div>
  )
}

export default PageHeader
